// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"123":"8fab2361","363":"9955a7d5","386":"27bff5a2"}[chunkId] + ".css";
};